import CountryPageRenderer from '../components/CountryPageRenderer';
import seychellesData from '../data/country-pages/seychelles';

export default function SeychellesCountryPage() {
  return <CountryPageRenderer data={seychellesData} />;
}
